module.exports = __webpack_public_path__ + "img/J5.be758a78.png";